export const OPEN_URL = (() => {
  return process.env.NODE_ENV === 'development' || location.hostname.includes('.dev.')
    ? 'http://open.dev.datastory.com.cn/'
    : 'https://open.datastory.com.cn/'
})()

export const IS_PRODUCTION = (() => {
  return process.env.NODE_ENV === 'production' && !location.hostname.includes('.dev.')
})()
